
import HistoriqueHotel from './HistoriqueHotel';
export default HistoriqueHotel;
